const state = () => ({
  open: false,
  activeView: null,
  payload: null
})

const getters = {
  isPanelOpen: (state) => state.open,
  activeView: (state) => state.activeView,
  panelPayload: (state) => state.payload
}

const mutations = {
  openPanel (state, { view, payload = null }) {
    state.open = true
    state.activeView = view
    state.payload = payload
  },
  closePanel (state) {
    state.open = false
  },
  resetPanel (state) {
    state.open = false
    state.activeView = null
    state.payload = null
  }
}

const actions = {
  openPanel ({ commit }, { view, payload = null }) {
    commit('openPanel', { view, payload })
  },
  togglePanel ({ commit, state }, { view, payload = null }) {
    if (state.open && state.activeView === view) {
      commit('closePanel')
    } else {
      commit('openPanel', { view, payload })
    }
  },
  closePanel ({ commit }) {
    commit('closePanel')
  },
  resetPanel ({ commit }) {
    commit('resetPanel')
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
